import { Component, Input } from '@angular/core';
import { CommissionPaymentStatus, CommissionRequest, commissionRequestPendingStatuses, commissionRequestSuccessStatuses } from '../../commission-request.types';

export interface CommissionRequestSummaryInput {
  commissionRequest: CommissionRequest | undefined;
  loadingAmountToPay: boolean;
  hasConvertedAmount: boolean;
  paymentAmount: string;
  paymentCurrency: string;
  convertedAmount: string | null;
  convertedCurrency: string | null;
  countryPayFrom: string;
  hasPayment: boolean;
}

enum BadgeStyle {
  NEUTRAL = 'neutral',
  WARNING = 'warning',
  SUCCESS = 'success',
  ERROR = 'critical',
  INFO = 'primary',
}

@Component({
  selector: 'commission-request-summary',
  templateUrl: './commission-request-summary.component.html',
  styleUrls: ['./commission-request-summary.component.scss']
})
export class CommissionRequestSummaryComponent {
  @Input() commissionRequest: CommissionRequest | undefined;
  @Input() loadingAmountToPay: boolean = false;
  @Input() hasConvertedAmount: boolean = false;
  @Input() paymentAmount: string = '';
  @Input() paymentCurrency: string = '';
  @Input() convertedAmount: string | null = null;
  @Input() convertedCurrency: string | null = null;
  @Input() countryPayFrom: string = '';
  @Input() hasPayment: boolean = false;

  commissionRequestStatus = CommissionPaymentStatus;

  get badgeStatusStyle(): string {
    const status = this.commissionRequest?.payment?.status;


    if (!status) {
      return BadgeStyle.INFO;
    } else if (commissionRequestPendingStatuses.includes(status)) {
      return BadgeStyle.INFO;
    } else if ([
      CommissionPaymentStatus.AUTHORIZED,
      CommissionPaymentStatus.PENDING_AUTHORIZATION
    ].includes(status)) {
      return BadgeStyle.WARNING;
    } else if (status === CommissionPaymentStatus.EXPIRED) {
      return BadgeStyle.ERROR;
    } else if ([
      CommissionPaymentStatus.IN_TRANSIT,
      CommissionPaymentStatus.PAID,
      CommissionPaymentStatus.CREDITED,
    ].includes(status)) {
      return BadgeStyle.SUCCESS;
    }

    return BadgeStyle.INFO;
  }

  get badgeStatusLabel(): string {
    const status = this.commissionRequest?.payment?.status;

    if (!status || commissionRequestPendingStatuses.includes(status)) {
      return 'transactions:statusOPEN';
    }

    return `transactions:status${status}`
  }

  get hasSuccessStatus(): boolean {
    const status = this.commissionRequest?.payment?.status;
    return status ? commissionRequestSuccessStatuses.includes(status) : false;
  }
}
